/**
 * CertMgmt - Resources -> Cert Mgmt screen.
 * Hosts the PROD and STAGE certificate inventories; both tabs share the same functionality.
 */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Tab, Tabs } from '@mui/material';
import { useLocation } from 'react-router-dom';

import { horizontalTabStyles } from '../../sharedStyles';
import CertMgmtTab from './CertMgmtTab';

const ENVIRONMENTS = ['PROD', 'STAGE'];

const useStyles = makeStyles(() => ({
    wrapper: {
        height: '100%',
    },
    ...horizontalTabStyles,
}));

function CertMgmt() {
    const classes = useStyles();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(() => Math.max(ENVIRONMENTS.indexOf(location.state?.environment), 0));

    // Alerts popup links pass the target environment via router state
    useEffect(() => {
        const idx = ENVIRONMENTS.indexOf(location.state?.environment);
        if (idx >= 0) setActiveTab(idx);
    }, [location.state]);

    return (
        <div className={classes.wrapper}>
            <div className={classes.tabWrapper}>
                <Tabs
                    value={activeTab}
                    onChange={(_event, newValue) => setActiveTab(newValue)}
                    aria-label="Cert Mgmt environment tabs"
                >
                    {ENVIRONMENTS.map(env => <Tab key={env} label={env} />)}
                </Tabs>
            </div>
            <div className={classes.tabBody}>
                <CertMgmtTab key={ENVIRONMENTS[activeTab]} env={ENVIRONMENTS[activeTab]} />
            </div>
        </div>
    );
}

export default CertMgmt;
